import React, { useEffect, useState } from 'react'
import { Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import ScoreRange from '../ScoreRange'
import { Button, Typography } from '@mui/material'
import SectionHeader from '@/components/UI/SectionHeader'

function FeedbackAndTutoring(props: any) {
  const [conditions, setConditions] = useState([])
  const { t } = useTranslation()

  useEffect(() => {
    if (props.conditions && props.conditions.length) {
      setConditions([...props.conditions])
    } else {
      setConditions([])
    }

    if (
      props.transformedQuestions &&
      Object.keys(props.transformedQuestions).length > 0
    ) {
      const quizzes: any[] = []
      Object.keys(props.transformedQuestions).map((questionId: any) => {
        if (props.transformedQuestions[questionId].id) {
          quizzes.push(props.transformedQuestions[questionId].id)
        }
      })
    }
    return () => {}
  }, [props])

  return (
    <>
      <div className="d-flex flex-wrap justify-content-between mb-24 align-items-start">
        <SectionHeader
          variant="tab"
          title={t('Feedback & Tutoring')}
          subtitle={t(
            'Create tutoring link and custom feedback for learner to review mistakes',
          )}
        />

        {conditions.length > 0 && (
          <Button
            variant="outlined"
            onClick={props.fetchAllLinkedQuizQuestions}
          >
            {t('Check for unlinked quiz questions')}
          </Button>
        )}

        <Button variant="outlined" onClick={props.updateCombinedQuizSettings}>
          {t('Save changes')}
        </Button>
      </div>
      <Row>
        <div className="mb-32 w-100">
          {conditions.length === 0 && (
            <div className="page-banner bg-page-wrapper text-center radius-8">
              <Typography variant="body4" mb={1}>
                {t(
                  'It looks like your quiz question & answers have not been linked. Click below to link them to your knowledge.',
                )}
              </Typography>
              <Button
                variant="contained"
                onClick={props.fetchAllLinkedQuizQuestions}
              >
                {t('Link quiz questions to knowledge')}
              </Button>
            </div>
          )}

          <div>
            {conditions.map((item, index) => {
              return (
                <ScoreRange
                  isFeedback={props.isFeedback}
                  key={item.id ? item.id : index.toString()}
                  buttonsData={props.transformData(
                    item.show.buttons ? item.show.buttons : [],
                  )}
                  buttonOptions={props.buttonOptions}
                  quizQuestionDropdownData={props.quizQuestionDropdownData}
                  conditionData={item}
                  conditionIndex={index}
                  removeScoreCondition={props.removeScoreCondition}
                  onConditionFieldChange={props.onConditionFieldChange}
                  onConditionQuestionDropdownChange={
                    props.onConditionQuestionDropdownChange
                  }
                  onButtonAdd={props.onButtonAdd}
                  onButtonLabelEdit={props.onButtonLabelEdit}
                  onButtonQuestionSelect={props.onButtonQuestionSelect}
                  onSort={props.onSort}
                  deleteButtonRow={props.deleteButtonRow}
                  questionIdLabelMap={props.questionIdLabelMap}
                  totalQuizScore={props.totalQuizScore}
                  hasIdPresent={item.id}
                  quizId={props.quizId}
                />
              )
            })}
          </div>
        </div>
      </Row>
    </>
  )
}

export default FeedbackAndTutoring
